module.exports = __webpack_public_path__ + "img/addicon.1be954ce.svg";